import React, {Component} from 'react';
import LivedAt from './LivedAt';
import nationalityOptions from "../../../utils/nationalities";
import TextInput from "../../Form/TextInput/TextInput";
import Select from "../../Form/Select/Select";
import withFeatureFlags from '../../FeatureFlags/withFeatureFlags';

/** @import {ManualEntryv2Props, ManualEntryv2State} from './ManualEntryv2Types' */
/** @import { WithFeatureFlagsProps } from '../../FeatureFlags/FeatureFlagsTypes' */
/** @import { OptionsType } from "react-select"; */
/** @import { OptionType } from "../../Form/Select/SelectTypes"; */

/** @extends {Component<ManualEntryv2Props & WithFeatureFlagsProps, ManualEntryv2State>} */
class ManualEntryv2 extends Component {
    /** @type {ManualEntryv2State} */
    state = {
        postCode: '',
        postCodeIsValid: false
    };

    firstRowFields = [
        { name: 'flatNumber', placeholder: 'Flat number', focus: true },
        { name: 'buildingNumber', placeholder: 'Building / House number' },
        { name: 'buildingName', placeholder: 'Building / House name' },
    ]

    secondRowFields = [
        { name: 'streetLine1', placeholder: 'Street line 1 *' },
        { name: 'streetLine2', placeholder: 'Street Line 2' },
        { name: 'town', placeholder: 'Town or city *' },
    ]
    
    thirdRowFields = [
        { name: 'postCode', placeholder: 'Postcode *' },
    ]

    forthRowFields = [
        { name: 'country', placeholder: 'Country *', type: 'select', options: nationalityOptions, nonEditable: true }
    ]

    required = {
        ands: [
            "streetLine1",
            "town",
            "postCode",
            "country"
        ],
        ors: [
            "flatNumber",
            "buildingNumber",
            "buildingName"
        ]
    };

    orsEmpty = () => {
        var empty = true;
        for (var i = 0; i < this.required.ors.length; i++) {
            if (this.props.fieldValues[this.required.ors[i]]) {
                empty = false;
            }
        }

        return empty;
    }

    fieldHasError = (/** @type {string} */ name) => {
        let fieldEmpty = false;

        if (this.required.ands.includes(name) && !this.props.fieldValues[name])
            fieldEmpty = true;

        if (this.required.ors.includes(name) && this.orsEmpty())
            fieldEmpty = true;

        return fieldEmpty && this.props.showValidation.showValidation && !this.props.disabled;
    }

    renderTextField = (/** @type {{
        name: string;
        placeholder: string;
        nonEditable?: boolean;
        focus?: boolean;
        formatter?: null | ((value: string) => string);
        valueOverride?: string | null;
    }} */ { name, placeholder, nonEditable, focus = false, formatter = null, valueOverride = null }) => {
        const showLabels = this.props.disabled && placeholder;

        if (this.props.disabled && !this.props.fieldValues[name]) {
            return null;
        }

        let value = valueOverride || this.props.fieldValues[name];
        if (formatter) {
            value = formatter(this.props.fieldValues[name]).toUpperCase();
        }

        return (
            <TextInput
                key={name}
                onChange={this.props.handleUpdateField(name)}
                name={name}
                placeholder={this.props.disabled ? placeholder.replace('*', '') : placeholder}
                disabled={nonEditable || this.props.disabled}
                value={value}
                hideLabels={!showLabels}
                label={this.props.disabled ? placeholder.replace('*', '') : placeholder}
                hasError={this.fieldHasError(name)}
            />
        );
    }

    renderSelectField = (/** @type {{
        type?: string;
        options?: OptionsType<OptionType>;
        name: string;
        placeholder: string;
        nonEditable?: boolean;
        focus?: boolean;
    }} */ { type = 'select', name, placeholder, nonEditable, options, focus = false }) => {
        let value = this.props.fieldValues[name];

        if (nonEditable) {
            const option = options && options.find(op => op && op.value === value);
            let title = option ? option.label : '';

            return this.renderTextField({
                name: name,
                placeholder: placeholder,
                nonEditable: nonEditable,
                focus: focus,
                valueOverride: title
            });
        }

        return (
            <Select
                key={name}
                placeholder={this.props.disabled ? placeholder.replace('*', '') : placeholder}
                options={options || []}
                onChange={this.props.handleUpdateField(name)}
                disabled={this.props.disabled}
                name={name}
                value={value ? nationalityOptions.filter(op => op.value === value)[0] : null}
                hasError={this.fieldHasError(name)}
            />
        );
    };

    renderField = (/** @type {{
        type?: string;
        options?: OptionsType<OptionType>;
        name: string;
        placeholder: string;
        nonEditable?: boolean;
        focus?: boolean;
    }} */ config) => {
        if (config.type !== 'select') {
            return this.renderTextField(config);
        }

        return this.renderSelectField(config);
    };

    render() {
        const { showValidation: { showValidation, errors} } = this.props;
        return (
            <>
                <div className='form-step__row'>
                    {this.firstRowFields.map(this.renderField)}
                </div>
                <div className='form-step__row'>
                    {this.secondRowFields.map(this.renderField)}
                </div>
                <div className='form-step__row'>
                    {this.thirdRowFields.map(this.renderField)}
                </div>
                <div className='form-step__row'>
                    {this.forthRowFields.map(this.renderField)}
                </div>

                <div className={showValidation && errors && errors.includes("invalidAddress") ? "login__error" : "login__error login__error--hide"}>
                    <span className="login__error--wrap">You must have a UK address to be able to apply</span>
                </div>
                <div className={showValidation && errors && errors.includes("invalidForm") ? "login__error" : "login__error login__error--hide"}>
                    <span className="login__error--wrap">Please enter a valid UK address.</span>
                </div>

                {this.props.withLivedAt && (
                    <LivedAt
                        disabled={this.props.disabled}
                        onChange={this.props.handleUpdateField('livedAt')}
                        livedAt={this.props.fieldValues.livedAt}
                    />
                )}
            </>
        );
    }
}

export default withFeatureFlags(ManualEntryv2);
